import React, { useEffect } from "react";
import { Container, Row, Col, Card, CardImg, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "../index.css";

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <>
      <Banner />
      <Content />
      <Details />
      <Information />
      <Industries />
    </>
  );
}

// Banner Section
function Banner() {
  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      <img
        src="/images/grass tiles.jpg"
        className="w-100"
        style={{ height: "auto", maxHeight: "700px", objectFit: "cover" }}
        alt="Cotton Banner"
      />
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "#fff",
          padding: "20px",
          borderRadius: "10px",
          textAlign: "center",
          fontFamily: "'Playfair Display', serif",
        }}
      >
        <h1>
          Your{" "}
          <span style={{ color: "#FFD700", fontWeight: "700" }}>Quality,</span>
        </h1>
        <h1>
          Our{" "}
          <span style={{ color: "#9bddff", fontWeight: "700" }}>Priority!</span>
        </h1>

        <Link to="/about">
          <button
            className="btn btn-outline-light mt-3"
            style={{ borderRadius: "5px" }}
          >
            Know more
          </button>
        </Link>
      </div>
    </div>
  );
}

// ✅ Content Section
function Content() {
  return (
    <Container className="my-5">
      <Row>
        {/* Description */}
        <Col xs={12} md={7}>
          <h1
            className="fw-bold"
            data-aos="fade-left"
            style={{ fontSize: "2.6rem" }}
          >
            Varay QC Services
          </h1>
          <br />
          <h3
            className="mb-4"
            data-aos="fade-left"
            style={{ fontSize: "2rem" }}
          >
            From Management Desk
          </h3>
          <p
            data-aos="fade-left"
            style={{
              fontSize: "1.15rem",
              lineHeight: "1.8",
              color: "#333",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            At{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              Varay QC Services
            </span>
            , quality isn’t a checkbox — it’s our{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>DNA</span>.
          </p>

          <p
            data-aos="fade-left"
            style={{
              fontSize: "1.15rem",
              lineHeight: "1.8",
              color: "#333",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            We work at the intersection of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              precision
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>trust</span>,
            ensuring every product we touch reflects the{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              highest standards
            </span>
            . From{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>tiles</span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              sanitaryware
            </span>{" "}
            to complex manufacturing outputs, our QC processes are designed to
            go beyond compliance — we aim for{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              confidence
            </span>
            .
          </p>

          <p
            data-aos="fade-left"
            style={{
              fontSize: "1.15rem",
              lineHeight: "1.8",
              color: "#333",
              fontFamily: "'Poppins', sans-serif",
            }}
          >
            In a market full of{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              shortcuts
            </span>{" "}
            and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              compromises
            </span>
            , we choose the long road — the one paved with{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>detail</span>,{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              accountability
            </span>
            , and{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              sharp eyes
            </span>
            . Our team doesn't just inspect; we{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              investigate
            </span>
            ,{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>
              validate
            </span>
            , and stand behind what we{" "}
            <span style={{ fontWeight: "600", color: "#007BFF" }}>certify</span>
            .
          </p>
        </Col>

        {/* Image */}
        <Col xs={12} md={5} className="mb-2" data-aos="fade-right">
          <Card style={{ width: "100%" }}>
            <CardImg
              src="/images/management Desk.avif"
              alt="Management Desk"
              style={{
                width: "100%",
                height: "430px",
                maxHeight: "430px",
                objectFit: "cover",
                borderRadius: "2px",
              }}
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
}

function Details() {
  return (
    <div>
      <h5 className="vqs-heading" data-aos="fade-left">
        If you're looking for{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>Quality</span>{" "}
        that speaks for itself, Welcome to{" "}
        <span style={{ fontWeight: "600", color: "#007BFF" }}>VQS!</span>
      </h5>

      <Container className="my-5">
        <Row>
          {/* Image */}
          <Col xs={12} md={6} className="mb-2" data-aos="fade-right">
            <Card style={{ width: "100%" }}>
              <CardImg
                src="/images/QC.png"
                alt="Management Desk"
                style={{
                  height: "400px",
                  width: "100%",
                  objectFit: "fit",
                }}
              />
            </Card>
          </Col>

          {/* Description */}
          <Col xs={12} md={6}>
            <div style={{ paddingTop: "1rem" }}>
              <p
                data-aos="fade-left"
                style={{
                  fontSize: "1.15rem",
                  lineHeight: "1.8",
                  color: "#333",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                At{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Varay QC Services
                </span>
                , we’re not just inspectors — we’re your{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  quality assurance partners
                </span>{" "}
                in India.
              </p>

              <p
                data-aos="fade-left"
                style={{
                  fontSize: "1.15rem",
                  lineHeight: "1.8",
                  color: "#333",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                We specialize in sourcing and inspection for{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Wall Tiles
                </span>
                ,
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Floor Tiles
                </span>
                ,
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Vitrified Tiles
                </span>
                ,
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Parking Tiles
                </span>
                ,
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Slab Tiles
                </span>
                , and{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Sanitaryware
                </span>
                , ensuring every detail — from finish to packaging — meets your
                exact expectations.
              </p>

              <p
                data-aos="fade-left"
                style={{
                  fontSize: "1.15rem",
                  lineHeight: "1.8",
                  color: "#333",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Our motto,
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  "Your Quality, Our Priority"
                </span>
                , is more than a tagline — it’s how we operate. From{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  edge precision
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  glaze quality
                </span>{" "}
                to{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  durability
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  packaging
                </span>
                , we leave no room for compromise.
              </p>

              <p
                data-aos="fade-left"
                style={{
                  fontSize: "1.15rem",
                  lineHeight: "1.8",
                  color: "#333",
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                With{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  Varay
                </span>
                , you don’t just get products inspected — you get{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  peace of mind
                </span>
                , built on{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  trust
                </span>{" "}
                and{" "}
                <span style={{ fontWeight: "600", color: "#007BFF" }}>
                  transparency
                </span>
                .
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

function Information() {
  return (
    <div
      style={{
        position: "relative",
        textAlign: "center",
        marginBottom: "3rem",
        padding: "0 1rem", // horizontal padding for small screens
      }}
      className="information-background"
    >
      <div
        style={{
          color: "#fff",
          padding: "2rem 1rem",
          maxWidth: "1200px",
          margin: "auto",
        }}
      >
        <h2
          className="fw-bold text-center"
          data-aos="fade-left"
          style={{
            fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
            marginBottom: "1.5rem",
            color: "#fff",
          }}
        >
          SERVICES | WE SERVE
        </h2>
        <Container className="my-4">
          <Row className="g-4 justify-content-center">
            {/* Card 1 */}
            {/* <Col xs={12} sm={6} md={4}>
              <Card
                className="h-100 d-flex flex-column"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    height: "320px", // Adjusted height for better visibility
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src="/images/card1.jpg"
                    alt="Product Sourcing"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  />
                </div>
                <Card.Body className="d-flex flex-column flex-grow-1">
                  <Card.Title
                    style={{ fontSize: "clamp(1.2rem, 4vw, 1.25rem)" }}
                  >
                    Product Sourcing
                  </Card.Title>
                  <Card.Text style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                    We identify and deliver high-quality products from trusted
                    global suppliers.
                  </Card.Text>
                  <Link to="/services/product-sourcing">
                    <Button variant="primary" size="sm">
                      Read More
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col> */}

            {/* Card 2 */}
            <Col xs={12} sm={6} md={4}>
              <Card
                className="h-100 d-flex flex-column"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    height: "320px", // Adjusted height for better visibility
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src="/images/card2.jpg"
                    alt="Supplier Verification"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  />
                </div>
                <Card.Body className="d-flex flex-column flex-grow-1">
                  <Card.Title style={{ fontSize: "1.25rem" }}>
                    Supplier Verification
                  </Card.Title>
                  <Card.Text style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                    Our team conducts in-depth checks to ensure supplier
                    credibility and compliance.
                  </Card.Text>
                  <Link to="/services/supplier-verification">
                    <Button variant="primary" size="sm">
                      Read More
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>

            {/* Card 3 */}
            <Col xs={12} sm={6} md={4}>
              <Card
                className="h-100 d-flex flex-column"
                style={{
                  backgroundColor: "rgba(255, 255, 255, 0.85)",
                  height: "100%",
                }}
              >
                <div
                  style={{
                    height: "320px", // Adjusted height for better visibility
                    overflow: "hidden",
                    position: "relative",
                  }}
                >
                  <Card.Img
                    variant="top"
                    src="/images/card3.jpg"
                    alt="Quality Assurance"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      position: "absolute",
                      top: 0,
                      left: 0,
                    }}
                  />
                </div>
                <Card.Body className="d-flex flex-column flex-grow-1">
                  <Card.Title style={{ fontSize: "1.25rem" }}>
                    Quality Assurance
                  </Card.Title>
                  <Card.Text style={{ fontSize: "0.9rem", flexGrow: 1 }}>
                    We implement strict controls to guarantee each product meets
                    global standards.
                  </Card.Text>
                  <Link to="/services/quality-assurance/">
                    <Button variant="primary" size="sm">
                      Read More
                    </Button>
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

function Industries() {
  const industries = [
    {
      img: "/images/wall Tiles industries 1.webp",
      title: "Wall Tiles",
      delay: 100,
    },
    {
      img: "/images/vitrified tiles industries.jpg",
      title: "Vitrified Tiles",
      delay: 300,
    },
    {
      img: "/images/floor tiles industries.webp",
      title: "Floor Tiles",
      delay: 200,
    },
    {
      img: "/images/sanitaryware industries.jpg",
      title: "Sanitary ware",
      delay: 400,
    },
    {
      img: "/images/Commercial.jpg",
      title: "Slab Tiles",
      delay: 500,
    },
    // Repeat for other industries
  ];

  return (
    <>
      <h2
        className="fw-bold text-center"
        data-aos="fade-left"
        style={{
          fontSize: "clamp(1.8rem, 5vw, 2.6rem)",
          marginTop: "3rem",
          padding: "0 1rem", // horizontal padding for phone screens
        }}
      >
        Industries We Serve
      </h2>
      <br />

      <div className="container px-3">
        <div className="row justify-content-center g-3">
          {industries.map(({ img, title, delay }, i) => (
            <div
              key={i}
              className="col-12 col-sm-6 col-md-4"
              data-aos="zoom-in"
              data-aos-delay={delay}
            >
              <img
                src={img}
                alt={title}
                className="img-fluid rounded"
                style={{
                  height: "auto",
                  maxHeight: "220px",
                  width: "100%",
                  objectFit: "cover",
                }}
              />
              <h3
                className="industry-title mt-2"
                style={{
                  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                  fontWeight: "700",
                  fontSize: "1.6rem",
                  color: "#2c3e50",
                  letterSpacing: "1.1px",
                  marginBottom: "8px",
                  textTransform: "uppercase",
                  borderBottom: "3px solid #3498db",
                  paddingBottom: "4px",
                }}
              >
                {title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
